import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'gs-gift-cards',
    templateUrl: './gift-cards.component.html',
    standalone: false
})

export class GiftCardsComponent {

  get charityCategoryId() : number {
    return environment.charityCategoryId;
  }

  constructor() {
  }
}
